/** Saved durations preserve rounding; an open timer uses elapsed, unpaused time. */
export function timeEntryHours(
  entry: {
    entryType?: string | null
    duration?: number | null
    startTime?: Date | string | null
    endTime?: Date | string | null
    isPaused?: boolean | null
    pausedAt?: Date | string | null
    pausedDuration?: number | null
  },
  now: Date = new Date(),
): number {
  const openTimer =
    entry.entryType === 'TIMER' && entry.startTime && !entry.endTime
  if (!openTimer && entry.duration != null && Number.isFinite(entry.duration))
    return Math.max(0, entry.duration)
  if (!entry.startTime) return 0
  const start = new Date(entry.startTime).getTime()
  const end = new Date(
    entry.endTime ??
      (entry.isPaused ? (entry.pausedAt ?? entry.startTime) : now),
  ).getTime()
  const paused = Math.max(0, entry.pausedDuration ?? 0) * 1000
  const hours = (end - start - paused) / 3_600_000
  return Number.isFinite(hours) ? Math.max(0, hours) : 0
}
